import React from "react";
import { ButtonProps, Theme } from "@literati/public-ui-shared-react";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepConfirmationSubscriptionPurchase from "components/Step/StepConfirmationSubscriptionPurchase";
import { Invoice } from "components/checkout/CheckoutOrderSummary";
import { Subscription } from "lib/api/subscription";

export const MembershipStepConfirmationPurchase = ({
  checkoutSession,
  invoice,
  routeNextStep,
  subscription,
  contentfulBoxImagesRaw,
}: MembershipState) => {
  const ctaLabel = "Complete Reader Profile";

  const buttonProps: ButtonProps = {
    onClick: () => routeNextStep?.(),
    children: ctaLabel,
  };

  return (
    <Theme>
      <StepConfirmationSubscriptionPurchase
        buttonProps={buttonProps}
        ctaLabel={ctaLabel}
        invoice={invoice as Invoice}
        readingLevelBoxImages={contentfulBoxImagesRaw}
        session={checkoutSession}
        showBanner={false}
        stepFooterProps={{
          nextButtonProps: buttonProps,
        }}
        subscription={subscription as Subscription}
        suppressTestimonialButton
        variant="button"
      />
    </Theme>
  );
};

export const MEMBERSHIP_STEP_CONFIRMATION_PURCHASE: MembershipStep = {
  component: MembershipStepConfirmationPurchase,
  id: "membership-id-purchase-confirmation",
  slug: "purchase-confirmation",
};

export default MembershipStepConfirmationPurchase;
